// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__AqaN6","requiredAsterisk":"Info_requiredAsterisk__2HsWu"};